import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  pricelistFilter: {
    padding: "20px 30px",
  },
}));

export default useStyles;
